import {observer} from "mobx-react";
import {ModalDialog} from "./ModalDialog";
import {DialogStoreInterface} from "../../store";

interface CancelModalDialogProps {
    store: DialogStoreInterface,
    execute: () => Promise<any>
}

const CancelModalDialog = observer(function CancelModalDialog({
    store,
    execute
                                                              }: CancelModalDialogProps) {
    return <ModalDialog
        store={store}
        actions={[
            {
                label: "Abbrechen",
                execute: async function () {
                    store.dialogOpen = false
                },
                className: 'is-primary is-rounded is-small'
            },
            {
                label: "Verwerfen",
                execute: async function () {
                    store.dialogOpen = false
                    await execute()
                },
                className: 'is-rounded is-small'
            }
        ]}
        title={"Änderungen verwerfen?"}
    >
        Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
    </ModalDialog>
})

export {
    CancelModalDialog
}
